import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import appClient from "../utils/appClient";
import axios from "axios";
import { useProjectContext } from "../context/ProjectContext";
import { useModal } from "../context/ModalContext";
// import { useAmdbContext } from "../context/AmdbContext";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { dispatch } = useProjectContext();
  const { dispatch: modalDispatch } = useModal();
  const generateNewId = async () => {
    //Updated code
    try {
      const response1 = await appClient.get(`/api/projects`);
      const allProjects = response1.data || [];

      // Extract and validate only project IDs that match the expected format
      const projectIds = allProjects
        .map((p: any) => p.project_id)
        .filter(
          (id: any) => typeof id === "string" && /^DIS2024\d{4}$/.test(id)
        );

      // Sort and get the last valid project ID
      const lastId = projectIds.sort().pop();
      let newId;

      if (!lastId) {
        newId = "DIS20240001";
      } else {
        const lastNumber = parseInt(lastId.replace("DIS2024", ""), 10);
        const newNumber = lastNumber + 1;
        newId = `DIS2024${newNumber.toString().padStart(4, "0")}`;
      }

      dispatch({ type: "SET_CURRENT_PROJECT_ID", payload: newId });
      dispatch({ type: "SET_SELECTED_PROJECT", payload: null });
      dispatch({ type: "SET_NEW_PROJECT", payload: "new" });
      return newId;
    } catch (error) {
      console.error("Error generating new project ID:", error);
      return null;
    }
  };
  return (
    <div className="h-full bg-white rounded-lg flex flex-col justify-around items-center">
      {/* Header Section */}
      <div className="flex-[1] bg-red flex items-center">
        <h1 className="p-0 m-0 text-4xl font-medium text-custom-blue7">
          Discovery
        </h1>
      </div>
      {/* Body Section */}
      <div className="flex-[6] flex flex-row justify-center items-center gap-6">
        <div>
          <img src="./Illustration.jpg" width={350} alt="Illustration" />
        </div>
        <div className="bg-white rounded-lg flex flex-col items-center justify-center gap-4">
          <div className="flex flex-col items-center gap-4 w-full">
            <>
              <h1 className="text-3xl font-medium text-custom-blue7 pl-2">
                Want to start new project?
              </h1>
              <button
                className="px-6 py-2 bg-custom-blue7 text-white font-medium rounded-md mt-2"
                onClick={() => {
                  generateNewId();
                  navigate("/projectcreationform");
                }}
              >
                Start New Project
              </button>
            </>
            {/* <div className="w-[400px] p-4 bg-custom-blue2 rounded-md shadow-md flex flex-col items-center">
              <h1 className="text-3xl font-medium text-custom-blue7 mb-2">
                Last Assessment
              </h1>
              <div className="flex justify-between w-full">
                <p className="text-custom-greytext text-lg font-medium">
                  Project Name:
                </p>
              </div>
              <div className="flex justify-between w-full">
                <p className="text-custom-greytext text-lg font-medium">
                  Status:
                </p>
                <p className="text-custom-greytext text-lg">Pending</p>
              </div>
              <button className="px-6 py-2 bg-custom-blue7 text-white font-medium rounded-md mt-4">
                View
              </button>
            </div> */}
          </div>
          {/* <>
            <h1 className="text-3xl font-medium text-custom-blue7 pl-2">
              No active assessments!
            </h1>
            <h1 className="text-3xl font-medium text-custom-blue7 pl-2">
              Start a new assessment to see insights.
            </h1>
            <button className="px-6 py-2 bg-custom-blue7 text-white font-medium rounded-md mt-2">
              Start New Assessment
            </button>
          </> */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
